var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTour3D = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 24 24",
  style: {
    enableBackground: "new 0 0 24 24"
  },
  xmlSpace: "preserve"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "_x33_d"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  d: "M9.1-0.8c0.7-0.3,1.5-0.2,2.2,0.1l0,0l0,0l8.4,3.6l0,0l0,0L20,3c0.3,0.2,0.6,0.5,0.8,0.8l-0.1-0.1 l0,0l0,0l0.1,0.1c0.2,0.3,0.3,0.7,0.3,1.1l0,0.2v11.8c0,0.5-0.1,0.9-0.3,1.3l0,0l-0.1,0.2c-0.2,0.3-0.5,0.6-0.9,0.7l0,0l-0.2-0.5 l0.2,0.5l-8.4,3.6l-0.2-0.5l-0.2-0.5l0,0l8.4-3.6c0.2-0.1,0.4-0.2,0.5-0.5l0,0l0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.6l0,0l0-11.8l0.6,0 l0,0l-0.6,0c0-0.1,0-0.2,0-0.4l-9.3,4l0,13.1c0,0,0,0,0,0l0.2-0.1l0.5,1C11,22.9,10.6,23,10.2,23l0,0c0,0,0,0,0,0 c-0.4,0-0.8-0.1-1.2-0.3l0,0l-8.4-3.6l0.2-0.5l0,0l-0.2,0.5l0,0l0,0L0.3,19c-0.3-0.2-0.6-0.5-0.8-0.8l0,0L-0.6,18 c-0.2-0.3-0.2-0.7-0.2-1.1l0,0l0-11.8l0-0.2c0-0.4,0.1-0.8,0.3-1.1l0,0l0.1-0.1c0,0,0,0,0-0.1c0.2-0.3,0.5-0.6,0.9-0.7l0,0l0,0 l0,0l8.4-3.6L9.1-0.8z M0.3,4.7c0,0.1,0,0.2,0,0.4l0,0l0,11.8c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.4,0.5,0.4l0,0l8.4,3.6 c0.1,0,0.1,0.1,0.2,0.1l0-13.1L0.3,4.7z M10.7,0.2c-0.4-0.1-0.9-0.1-1.4,0.1l0,0l0,0L1.1,3.8l9,3.9l9-3.9l-8.2-3.5l0,0L10.7,0.2z"
})))));
export { SvgTour3D as ReactComponent };
export default __webpack_public_path__ + "images/tour3d.svg";